export const FEATURES = {
  AI_CONTENT_GENERATION: 'ai-content-generation',
  TRAINING_SCHEDULE: 'training-schedule',
};
